import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateServiceAreaOverrideRuleStatus } from '../../../api/plan-service-area-override-rules-api'
import type { PlanServiceAreaOverrideRuleStatus } from '../enums/plan-service-area-override-rule.enum'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'
import { SERVICE_AREA_OVERRIDE_RULE_QUERY_KEY } from './useGetServiceAreaOverrideRule'

interface Variables {
  id: string
  status: PlanServiceAreaOverrideRuleStatus
}

export function useToggleServiceAreaOverrideRuleStatus() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, Variables>({
    mutationFn: ({ id, status }) =>
      updateServiceAreaOverrideRuleStatus(id, { status }),
    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULE_QUERY_KEY, variables.id],
      })
    },
  })
}
